module.exports = __webpack_public_path__ + "hyperion-v2-static/img/seerist_logo_black_text.3804d199.png";